export function useProductUrlParams() {
    const route = useRoute();

    const url = route.params.id;
    const matches = url.match(/-n(\d+)(?:-(\d+))?$/);

    const id = matches?.[1] || null
    const optionId = matches?.[2] || null

    return {
        id,
        optionId
    };
}